import React, { useState } from "react";
import Slider from 'react-slick';

const TestimonialTab = ({updateTestimonialTabData,testimonialTabData}) => {
    //const [widthLayoutCustomise, setLayoutCustomiseWidth] = useState(20); 
    const [showReviewerName, setReviewerName] = useState(Number(testimonialTabData.testimonial_is_show_reviewer_name));
    const [showReviewerVerifiedBadge, setReviewerVerifiedBadge] = useState(Number(testimonialTabData.testimonial_is_show_verified_badge));
    const [showReviewerPicture, setReviewerPicture] = useState(Number(testimonialTabData.testimonial_is_show_reviewer_picture));
    const [showReviewerCaption, setReviewerCaption] = useState(Number(testimonialTabData.testimonial_is_show_caption));
    const [showDate, setShowDate] = useState(Number(testimonialTabData.testimonial_is_show_date));
    const [showRating, setShowRating] = useState(Number(testimonialTabData.testimonial_is_show_rating));
    const [showImages, setShowImages] = useState(Number(testimonialTabData.testimonial_is_show_images));
    const [showLogo, setShowLogo] = useState(Number(testimonialTabData.testimonial_is_show_logo));

    // Handlers Reviewer Name Change
    const handleReviewerNameChange = (e) => {
        const checked = e.target.checked;
        setReviewerName(checked);
        updateTestimonialTabData("testimonial_is_show_reviewer_name", checked); 
    };

    // Handlers Reviewer Verified Badge Change
    const handleReviewerVerifiedBadgeChange = (e) => {
        const checked = e.target.checked;
        setReviewerVerifiedBadge(checked);
        updateTestimonialTabData("testimonial_is_show_verified_badge", checked); 
    };

    // Handlers Reviewer Picture Change
    const handleReviewerPictureChange = (e) => {
        const checked = e.target.checked;
        setReviewerPicture(checked);
        updateTestimonialTabData("testimonial_is_show_reviewer_picture", checked); 
    };

    // Handlers Reviewer Caption Change
    const handleReviewerCaptionChange = (e) => {
        const checked = e.target.checked;
        setReviewerCaption(checked);
        updateTestimonialTabData("testimonial_is_show_caption", checked); 
    };

    // Handlers Show Date Change
    const handleShowDateChange = (e) => {
        const checked = e.target.checked;
        setShowDate(checked);
        updateTestimonialTabData("testimonial_is_show_date", checked); 
    };

    // Handlers Show Rating Change
    const handleShowRatingChange = (e) => {
        const checked = e.target.checked;
        setShowRating(checked);
        updateTestimonialTabData("testimonial_is_show_rating", checked); 
    };

    // Handlers Show Images Change
    const handleShowImagesChange = (e) => {
        const checked = e.target.checked;
        setShowImages(checked);
        updateTestimonialTabData("testimonial_is_show_images", checked); 
    };

    // Handlers Show Logo Change
    const handleShowLogoChange = (e) => {
        const checked = e.target.checked;
        setShowLogo(checked);
        updateTestimonialTabData("testimonial_is_show_logo", checked); 
    };


    const testimonialStyleSliderImages = [
        //`${process.env.PUBLIC_URL}/testimonials/templates/classic-1.png`,
        //`${process.env.PUBLIC_URL}/testimonials/templates/classic-2.png`,
        //`${process.env.PUBLIC_URL}/testimonials/templates/classic-3.png`,
        `${process.env.PUBLIC_URL}/testimonials/templates/classic-4.png`,
        `${process.env.PUBLIC_URL}/testimonials/templates/classic-4.png`,
    ];

    const TestimonialStyleSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
    };

    return (
        <div className="testimonials-side-baar-testimonial-tab">
            <span>Testimonial</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Style</span>
                    <div className="slider-review slider-review-one">
                        <Slider {...TestimonialStyleSettings}>
                            {testimonialStyleSliderImages.map((image, index) => (
                                <div key={index}>
                                    <img src={image} alt={`slider-image-${index}`} className="slider-image" />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
            
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show Reviewer Name</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle1" className="chkbx-toggle" type="checkbox" checked={showReviewerName} onChange={handleReviewerNameChange} />
                        <label for="setting_open_link_in_new_tab_toggle1"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Verified Badge</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle2" className="chkbx-toggle" type="checkbox" checked={showReviewerVerifiedBadge} onChange={handleReviewerVerifiedBadgeChange} />
                        <label for="setting_open_link_in_new_tab_toggle2"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Reviewer Picture</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle3" className="chkbx-toggle" type="checkbox" checked={showReviewerPicture} onChange={handleReviewerPictureChange} />
                        <label for="setting_open_link_in_new_tab_toggle3"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Caption</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle4" className="chkbx-toggle" type="checkbox" checked={showReviewerCaption} onChange={handleReviewerCaptionChange} />
                        <label for="setting_open_link_in_new_tab_toggle4"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Date</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle5" className="chkbx-toggle" type="checkbox" checked={showDate} onChange={handleShowDateChange} />
                        <label for="setting_open_link_in_new_tab_toggle5"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Rating</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle6" className="chkbx-toggle" type="checkbox" checked={showRating} onChange={handleShowRatingChange} />
                        <label for="setting_open_link_in_new_tab_toggle6"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Images</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle7" className="chkbx-toggle" type="checkbox" checked={showImages} onChange={handleShowImagesChange} />
                        <label for="setting_open_link_in_new_tab_toggle7"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Logo</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle8" className="chkbx-toggle" type="checkbox" checked={showLogo} onChange={handleShowLogoChange} />
                        <label for="setting_open_link_in_new_tab_toggle8"></label>
                    </div>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show Reviewer Name</span>
                    <em>{testimonialTabData.testimonial_show_reviewer_name}</em>
                </div>
            </div>
           {/*<div className="side-baar-box-header">
                <div className="box-header-row">
                    <h6 className="h6-tage">How to Display Review Text</h6>
                    <div className="left-cnater-right-button">
                        <label cclassName="card-radio-btn">
                            <input className="card-input-element d-none" type="radio" value="left" name="alignment_type" wfd-id="id6" />
                            <div className="card card-body">
                                <div className="content_sub">Short</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input className="card-input-element d-none" type="radio" value="center" name="alignment_type" wfd-id="id7" />
                            <div className="card card-body">
                                <div className="content_sub">Full</div>
                            </div>
                        </label>
                    </div>
                    <h6 className="h6-tage">Preview Text Length</h6>
                    <div className="slider-container testimonial-slider-container">
                    <input 
                        type="range" 
                        min="20" 
                        max="100" 
                        value={widthLayoutCustomise} 
                        onChange={(e) => setLayoutCustomiseWidth(Number(e.target.value))} 
                    />
                    <div className="labels">
                        <span className="value">Brief</span>
                        <span className="width-1920">Extended</span>
                    </div>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Align Cards by Height</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle9" className="chkbx-toggle" type="checkbox" value="1" />
                        <label for="setting_open_link_in_new_tab_toggle9"></label>
                    </div>
                </div>
            </div>*/}
        </div>
    );
};

export default TestimonialTab;